import { render, staticRenderFns } from "./devBtns.vue?vue&type=template&id=5c0f3bdf&scoped=true&"
import script from "./devBtns.vue?vue&type=script&lang=js&"
export * from "./devBtns.vue?vue&type=script&lang=js&"
import style0 from "./devBtns.vue?vue&type=style&index=0&id=5c0f3bdf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0f3bdf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\uat\\platform-uat\\Platform-foundation-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c0f3bdf')) {
      api.createRecord('5c0f3bdf', component.options)
    } else {
      api.reload('5c0f3bdf', component.options)
    }
    module.hot.accept("./devBtns.vue?vue&type=template&id=5c0f3bdf&scoped=true&", function () {
      api.rerender('5c0f3bdf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/devBtns/devBtns.vue"
export default component.exports